import "./SkeletonLoader.css";

type SkeletonLoaderProps = {
  type: "card" | "table" | "chart";
  rows?: number;
};

export function SkeletonLoader({ type, rows = 5 }: SkeletonLoaderProps) {
  if (type === "table") {
    return (
      <div class="skeleton-loader skeleton-loader--table" aria-hidden="true">
        <div class="skeleton-loader__row skeleton-loader__row--header">
          <div class="skeleton skeleton-loader__cell"></div>
          <div class="skeleton skeleton-loader__cell"></div>
          <div class="skeleton skeleton-loader__cell"></div>
        </div>
        {Array.from({ length: rows }).map((_, index) => (
          <div key={index} class="skeleton-loader__row">
            <div class="skeleton skeleton-loader__cell"></div>
            <div class="skeleton skeleton-loader__cell"></div>
            <div class="skeleton skeleton-loader__cell"></div>
          </div>
        ))}
      </div>
    );
  }

  if (type === "chart") {
    return (
      <div
        class="skeleton-loader skeleton-loader--chart skeleton"
        aria-hidden="true"
      ></div>
    );
  }

  return (
    <div class="skeleton-loader skeleton-loader--card" aria-hidden="true">
      <div class="skeleton skeleton-loader__title"></div>
      <div class="skeleton skeleton-loader__text"></div>
      <div class="skeleton skeleton-loader__text skeleton-loader__text--short"></div>
    </div>
  );
}
